import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { App } from './App';
import { AuthProvider } from './contexts/auth-context';
import { Toaster } from './components/ui/sonner';
import { queryClient, persistOptions } from './lib/query-client';
import './lib/i18n'; // side-effect: initializes i18next before anything calls useTranslation()
import './styles/index.css';

// PersistQueryClientProvider = the normal provider + a localStorage-backed cache that survives page
// reloads. On boot it rehydrates the last-seen data so screens paint instantly, then queries that
// are stale (past their staleTime) refetch silently in the background (the fetch is surfaced by the
// FetchingBar, not a spinner). The client + persist config live in lib/query-client so the auth
// layer can bust the cache on logout / user-switch.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
      {/* One app-wide toast surface; pages report outcomes via notify* from lib/toast. */}
      <Toaster />
    </PersistQueryClientProvider>
  </React.StrictMode>,
);
